import {safeText} from "../../js/util/CommonUtils.js";

export default class IconWithDropdownMenuHtml {
    /** @type {HTMLElement} */
    #parent;
    /** @type {string} will be used in material icon span, for example "arrow_drop_down" */
    #iconText;
    #hideMenuFunction;
    #onItemClickCallbacks = {};

    constructor() {
        this.#hideMenuFunction = this.#hide.bind(this);
    }

    /**
     * @param {HTMLElement} parent
     * @param {string} iconText 
     */
    init(parent, iconText) {
        this.#parent = parent;
        this.#iconText = iconText;
    }

    /**
     * @param {{
     *     id: string,
     *     name: string,
     *     title?: string,
     *     disabled?: boolean,
     *     hidden?: boolean
     * }[]} params
     */
    show(params){
        this.#parent.insertAdjacentHTML('beforeend', this.#template(params));
        this.#addListenersToMenuItems()
    }

    /**
     * @param {string} itemId
     * @param {function} cb
     */
    onItemClick(itemId, cb) {
        if (!Array.isArray(this.#onItemClickCallbacks[itemId]))
            this.#onItemClickCallbacks[itemId] = [];
        this.#onItemClickCallbacks[itemId].push(cb);
    }

    /**
     * @param {string} id
     * @param {string} name
     * @param {string} value
     */
    setMenuItemAttribute(id, name, value){
        const element = this.#parent.querySelector(`#${id}`);
        element.setAttribute(name, value)
    }

    /**
     * @param {string} id
     * @param {string} name
     */
    removeMenuItemAttribute(id, name){
        const element = this.#parent.querySelector(`#${id}`);
        element.removeAttribute(name)
    }

    #show() {
        window.addEventListener('click', this.#hideMenuFunction);
        this.#getMenuElement().removeAttribute('data-hidden');
    }

    #hide() {
        this.#getMenuElement().setAttribute('data-hidden', "true");
        window.removeEventListener('click', this.#hideMenuFunction);
    }

    #isVisible() {
        return !this.#getMenuElement().hasAttribute('data-hidden');
    }

    #getMenuElement() {
        return this.#parent.querySelector('.icon-with-dropdown-menu__menu-below');
    }

    #onMenuItemClick(event) {
        const item = event.target.closest('li');
        for (const cb of this.#onItemClickCallbacks[item.id])
            cb();
        this.#hide();
    }

    #toggleMenuVisibility(event){
        event.stopPropagation();
        if (this.#isVisible())
            this.#hide();
        else
            this.#show();
    }

    #addListenersToMenuItems() {
        const burgerIcon = this.#parent.querySelector('.icon-with-dropdown-menu__icon');
        burgerIcon.addEventListener('click', (event) => {
            this.#toggleMenuVisibility(event)
        })
        const menuItems = this.#parent.querySelectorAll('.icon-with-dropdown-menu__menu-item');
        for (const item of menuItems){
            if (!item.hasAttribute('disabled')) {
                item.addEventListener('click', this.#onMenuItemClick.bind(this))
            }
        }
    }

    /**
     * @param {{
     *     id: string,
     *     name: string,
     *     title?: string,
     *     disabled?: boolean,
     *     hidden?: boolean
     * }} param
     */
    #menuItemTemplate(param) {
        let {id, name, title, disabled, hidden, iconName} = param;
        if (hidden)
            return ''
        name = name ? name : '';
        title = title || '';
        disabled = disabled ? "disabled" : '';
        const icon = iconName ?
            `<span class="material-symbols-outlined icon-with-dropdown-menu__menu-below-icon">${safeText(iconName)}</span>` : "";

        return `<li id=${safeText(id)} class="icon-with-dropdown-menu__menu-item" title="${safeText(title)}" ${disabled}>
                          ${icon}                         
                          <span>${safeText(name)}</span>
                        </li>`
    }

    /**
     * @param {{
     *     id: string,
     *     name: string,
     *     title?: string,
     *     disabled?: boolean,
     *     hidden?: boolean
     * }[]} params
     */
    #template(params) {
        return `
        <div class="icon-with-dropdown-menu">
            <span popovertarget="icon-with-dropdown-menu" class="material-symbols-outlined icon-with-dropdown-menu__icon">${this.#iconText}</span>
            <menu popover id="icon-with-dropdown-menu" class="icon-with-dropdown-menu__menu-below" data-hidden>
              ${params.map(param=>this.#menuItemTemplate(param)).join(" ")}
            </menu>
        </div>
        `
    }
}
